export async function setupMockService() {
  const { setupWorker } = await import('msw/browser');
  const { handlers } = await import('./handlers');

  const worker = setupWorker(...handlers);

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}
